import { http } from './http'

export const getActiveAdvertisement = () => {
  return http().get('/api/advertisements');
}
